import React from 'react';
import Hero from './components/IQAC/activities/Hero';
import Main from './components/IQAC/activities/Main';

const IqacActivities = () => {
    return (
        <div>
            <Hero />
            <Main />
        </div>
    )
}

export default IqacActivities;